module.exports = __webpack_public_path__ + "img/next.ff2b9671.svg";